import { render, staticRenderFns } from "./SapSyncParams.vue?vue&type=template&id=32d1022c"
import script from "./SapSyncParams.vue?vue&type=script&lang=js"
export * from "./SapSyncParams.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports